import styled from 'styled-components';

import { UserProfilePhoto } from '../../core/Image';

export const ViewContactHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ViewContactHeaderLCM = styled(ViewContactHeader)`
  font-size: 14px;
`;

export const ViewContactHeaderMain = styled.div`
  display: flex;
  flex-grow: 1;
  font-size: 14px;
  align-items: center;

  ${UserProfilePhoto} {
    margin-right: 6px;
  }
`;

export const ViewContactNameContainer = styled.div`
  margin-left: 6px;
`;

export const ViewContactName = styled.h3`
  font-size: 18px;
  line-height: 1.5;
  letter-spacing: 0.44px;
  color: rgba(0, 0, 0, 0.87);
  margin-top: 4px;
  margin-bottom: 0;
`;

export const ViewContactNameLCM = styled(ViewContactName)`
  font-size: 16px;
`;

export const ViewContactIconEdit = styled.img`
  max-width: 32px;
  max-height: 32px;
  cursor: pointer;
`;

export const ViewContactIconTrash = styled.img`
  max-width: 30px;
  max-height: 30px;
  margin-left: 2px;
  cursor: pointer;
`;

export const ViewContactIconClose = styled.img`
  max-width: 30px;
  max-height: 30px;
  cursor: pointer;
`;

export const ViewContactSubtitle = styled.h4`
  font-size: 14px;
  margin-left: 6px;
  margin-top: 16px;
`;
